import { ICategory } from '@/types/interfaces/navigator';

export default {
	name: 'satpaiDoner',
	value: 'categories.satpaiDonerTitle',
	title: 'categories.satpaiDonerTitle',
	position: 9,
	image:
		'https://rahmet.object.pscloud.io/static-files/assets/satpai-group/doner.png',
	payload: {
		search: `Doner na Satpayeva`
	}
} as ICategory;
